<template>
  <div>
    <div v-if="title" class="title">
      <h3 id="spotifyLabel" class="section-title">{{ title }}</h3>
      <div class="separator" />
    </div>
    <div v-if="iframe" v-html="iframe"></div>
    <iframe
      v-else-if="iframeUrl"
      style="border-radius:12px"
      title="Spotify reproductor"
      :width="width"
      :height="height"
      frameBorder="0"
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
      :src="iframeUrl"
      aria-hidden="false"
      aria-label="Spotify reproductor"
      aria-labelledby="spotifyLabel"
      aria-live="polite"
    />
  </div>
</template>

<script setup>
import { toRefs, computed } from "vue";

const props = defineProps({
  type: {
    type: String,
    default: undefined
  },
  id: {
    type: Object,
    default: undefined
  },
  iframe: {
    type: String,
    default: ""
  },
  title: {
    type: String,
    default: undefined
  },
  height: {
    type: Number,
    default: 200
  },
  width: {
    type: String,
    default: "100%"
  }
});
const { type, id, iframe, title, height } = toRefs(props);
const iframeUrl = computed(() => {
  try {
    let url = "";
    if (type.value === "artist")
      return `https://open.spotify.com/embed/artist/${id.value}?utm_source=generator&theme=0`;
    return url;
  } catch (err) {
    return null;
  }
});
</script>

<style></style>
